module.exports = __webpack_public_path__ + "logo.svg?7df75e04ec5b61dddb974acf9c06b1a3";